'<template lang="html">
  <div id="EditInformationPage">
    <div class="brs" v-if="edit_trigger"></div> <!--フェード用-->
    <el-button　type="success" round v-on:click="show">お知らせの追加をする</el-button>
    <div>
      <!--お知らせ一覧表示部-->
      <h1>お知らせ一覧</h1>
      <ol id="information_list" class="information_lists">
        <li
        v-for="(information_list, index) in information_list"
        :key="'information_list' + index"
        >
        <p id="information_list_body" >
          <table>
            <tr>
              <td style="width:10%;">
                <a class="information_list_day">{{information_list.day}}</a>
              </td>
              <td style="width:80%;">
                <a id="information_list_text" v-html='information_list.text'></a>
              </td>
              <td style="width:5%;">
                <i @click="delete_information(information_list.information_id)" class="delete_button icon-trash"></i>
              </td>
              <td style="width:5%;">
                <i @click="Edit_trigger(index)" class="delete_button icon-editalt"></i>
              </td>
            </tr>
          </table>
        </p>
        </li>
      </ol>
    </div>
    <modal name="edit"
      :scrollable="true"
      classes=""
      :width="800"
      height="auto">
       <div class="Edit_information">
         <h1>編集画面</h1>
         <vue-editor class="editor" v-model="edit_text" :editorToolbar="customToolbar"></vue-editor>
         <table>
           <tr>
             <td>
               <el-input placeholder="対象者" v-model="edit_target"></el-input>
             </td>
             <td>
               <el-select v-model="edit_importance" placeholder="重要度">
                 <el-option
                   v-for="item in importance"
                   :key="item.value"
                   :label="item.label"
                   :value="item.value">
                 </el-option>
               </el-select>
             </td>
           </tr>
         </table>
        <button type="button" @click="Edit_information" class="add_button">追加</button>
       </div>
    </modal>
    <modal name="hello-world"
       :scrollable="true"
       classes=""
       :width="800"
       height="auto">
       <div class="new_information">
         <!--お知らせ新規作成部-->
         <h1>お知らせ新規作成</h1>
         <vue-editor class="editor" v-model="information_text" :editorToolbar="customToolbar"></vue-editor>
         <table>
           <tr>
             <td>
               <el-input placeholder="対象者" v-model="target"></el-input>
             </td>
             <td>
               <el-select v-model="importance_value" placeholder="重要度">
                 <el-option
                   v-for="item in importance"
                   :key="item.value"
                   :label="item.label"
                   :value="item.value">
                 </el-option>
               </el-select>
             </td>
             <td v-if="importance_value == '緊急'">
               <el-date-picker
                v-model="show_date"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="表示期間">
              </el-date-picker>
             </td>
           </tr>
         </table>
         <button type="button" @click="add_information" class="add_button">追加</button>
       </div>
   </modal>
  </div>
</template>

<script>
import moment from 'moment'
import { VueEditor } from 'vue2-editor'

import {
  mapActions
} from 'vuex'
export default {
  name: 'user-list',
  data () {
    return {
      show_date: null,
      customToolbar: [
        [{size: ['small', false, 'large', 'huge']}],
        ['bold', 'italic', 'underline', 'strike'],
        [{'align': ''}, {'align': 'center'}, {'align': 'right'}, {'align': 'justify'}],
        [{ list: 'ordered' }, { list: 'bullet' }],
        [{color: []}, {background: []}],
        [{indent: '-1'}, {indent: '+1'}],
        ['link']
      ],
      content: null,
      information_list: [],
      information_text: '',
      edit_trigger: false,
      edit_id: '',
      edit_text: '',
      edit_target: '',
      edit_importance: '',
      time: new Date(),
      target: null,
      importance_value: null,
      importance: [
        {
          value: '最重要',
          label: '最重要'
        },
        {
          value: '重要',
          label: '重要'
        },
        {
          value: '緊急',
          label: '緊急'
        },
        {
          value: '障害情報',
          label: '障害情報'
        },
        {
          value: 'お知らせ',
          label: 'お知らせ'
        }
      ],
      url: null
    }
  },
  components: {
    VueEditor
  },
  mounted () {
    this.getInformation().then((res) => {
      this.information_list = res
    })
  },
  methods: {
    ...mapActions([
      'getInformation',
      'addinformation',
      'deleteinformation',
      'editinformation'
    ]),
    moment: moment,
    formattedDate (date) {
      return moment(date, 'YYYY-MM-DD').format('YYYYMMDD')
    },
    add_information () {
      if (!this.information_text) {
        this.$notify({
          title: '警告',
          message: '内容を入力してください',
          customClass: 'error',
          offset: 50,
          type: 'error'
        })
        return
      }
      if (!this.target) {
        this.$notify({
          title: '警告',
          message: '対象を入力してください',
          customClass: 'error',
          offset: 50,
          type: 'error'
        })
        return
      }
      if (!this.importance_value) {
        this.$notify({
          title: '警告',
          message: '重要度を入力してください',
          customClass: 'error',
          offset: 50,
          type: 'error'
        })
        return
      }
      if (this.importance_value === '緊急') {
        if (!this.show_date) {
          this.$notify({
            title: '警告',
            message: '期間を入力してください',
            customClass: 'error',
            offset: 50,
            type: 'error'
          })
          return
        }
      }
      this.addinformation({
        day: this.formattedDate(this.time),
        text: this.information_text,
        target: this.target,
        importance: this.importance_value,
        show_date: this.show_date
      }).then((res) => {
        if (res !== 1) {
          this.$notify({
            title: '成功',
            message: 'お知らせの登録に成功しました。',
            customClass: 'notify',
            offset: 50,
            type: 'success'
          })
          this.getInformation().then((res) => {
            this.information_list = res
          })
          this.information_text = ''
          this.hide()
        }
      })
    },
    delete_information (id) {
      let yesno = confirm('お知らせを削除します． よろしいでしょうか？')
      if (yesno) {
        this.deleteinformation(id)
        .then((res) => {
          if (res !== 1) {
            this.$notify({
              title: '成功',
              message: 'お知らせの削除に成功しました。',
              offset: 50,
              type: 'success'
            })
            this.getInformation().then((res) => {
              this.information_list = res
            })
            this.information_text = ''
          }
        })
      }
    },
    Edit_trigger (id) {
      if (this.edit_trigger === false) {
        this.edit_id = this.information_list[id].information_id
        this.edit_text = this.information_list[id].text
        this.edit_target = this.information_list[id].target
        this.edit_importance = this.information_list[id].importance
        this.$modal.show('edit')
      } else {
        this.edit_id = ''
        this.edit_text = ''
        this.edit_target = ''
        this.edit_importance = ''
        this.$modal.hide('edit')
      }
    },
    close_editer () {
      if (this.edit_trigger === false) {
        this.$modal.show('edit')
      } else {
        this.$modal.hide('edit')
      }
    },
    Edit_information () {
      let yesno = confirm('お知らせの変更を確定します。 よろしいでしょうか？')
      if (yesno) {
        var data = {
          id: this.edit_id,
          text: this.edit_text,
          target: this.edit_target,
          importance: this.edit_importance
        }
        this.editinformation(data)
        .then((res) => {
          if (res !== 1) {
            this.$notify({
              title: '成功',
              message: 'お知らせの変更に成功しました。',
              offset: 50,
              type: 'success'
            })
            this.getInformation().then((res) => {
              this.information_list = res
            })
            this.edit_trigger = false
          }
        })
      }
    },
    show () {
      this.$modal.show('hello-world')
    },
    hide () {
      this.$modal.hide('hello-world')
    }
  }
}
</script>
<style lang="css" scoped>
ol.information_lists{
  width: 95%;
  overflow: auto;
  max-height: 450px;
  counter-reset:list;
  list-style-type:none;
  font: 14px/1.6 'arial narrow', sans-serif;
  padding:0;
}
ol.information_lists li{
  position:relative;
  margin: 7px 0 7px 0px;
  padding-left:100px;
  font-weight: bold;
  font-size:16px;
  line-height: 30px;
  border: 2px solid #756C67;
  border-radius: 5px;
  color: #756C67;
}
.information_list_day{
  position: absolute;
  left: 0px;
  width: 100px;
  height: 100%;
  text-align: center;
  color: #fff;
  line-height:30px;
  background: #756C67;
  top: 50%;
  -moz-transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}
.itemEven{
  background-color: rgb(152, 241, 217);
}
textarea{
  width: 80%;
}
.add_button{
  font-size: 20px;
  margin: 5px auto;
  display: block;
  padding: 0.25em 0.5em;
  text-decoration: none;
  color: #FFF;
  background: #fd9535;/*色*/
  border-radius: 4px;/*角の丸み*/
  box-shadow: inset 0 2px 0 rgba(255,255,255,0.2), inset 0 -2px 0 rgba(0, 0, 0, 0.05);
  font-weight: bold;
  border: solid 2px #d27d00;/*線色*/
}
.add_button:active {/*押したとき*/
    box-shadow: 0 0 2px rgba(0, 0, 0, 0.30);
}
.add_button:active {/*ボタンを押したとき*/
  -ms-transform: translateY(4px);
  -webkit-transform: translateY(4px);
  transform: translateY(4px);/*下に動く*/
  border-bottom: none;/*線を消す*/
}
.close_button{
  color: #FFFFFF;
  font-size: 30px;
  position: absolute;
  top: 5px;
  right: 5px;
}
.close_button:hover{
  color: #d6d6d6;
  opacity: 0.5;
}
.delete_button{
  font-size: 25px;
  margin: 1px;
  float: right;
}
.delete_button:hover{
  color: #423a35;
}
.Edit_information{
  margin: 10px auto;
  border:  2px solid #746054;
  background-color: #ad998c;
  border-radius: 10px;
}
.new_information{
  margin: 10px auto;
  border:  2px solid #746054;
  background-color: #ad998c;
  border-radius: 10px;
}
.brs{
  top: 0;
  width: 100%;
  height: 100%;
  position: fixed;
  background-color: rgba(0, 0, 0, 0.49);
}
.notify{
  top: 200px;
}
.modalstyle{
  background-color: red;
  text-align: left;
  border-radius: 3px;
  box-shadow: 0 20px 60px -2px rgba(27, 33, 58, 0.4);
  padding: 0;
}
.editor{
  background-color: rgb(252, 252, 252);
}
table{
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// EditInformationPage.vue?41fbd304